<script setup>
import { computed } from 'vue';
import SelectOptionV4 from './SelectOptionV4';

import '../styles/configurator-selection.css';

const emit = defineEmits(['select', 'update:modelValue']);
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Object,
    default: () => {
      return null;
    },
  },
  options: {
    type: Array,
    required: true,
  },
  showDescription: {
    type: Boolean,
    default: true,
  },
  showInformation: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isInsidePackage: {
    type: Boolean,
    default: false,
  },
  disabledSelections: {
    type: Array,
    default: () => [],
  },
  justifyContentCenter: {
    type: Boolean,
    default: false,
  },
  isNextToOthers: {
    type: Boolean,
    default: false,
  },
  optionsContainerStyle: {
    type: Object,
    default: () => {},
  },
  titleCustomStyle: {
    type: Object,
    default: () => {},
  },
});

const select = (option) => {
  emit('select', { option, type: props.type });
  emit('update:modelValue', option);
};

const singleOption = computed(() => props.options?.length === 1);

</script>

<template>
  <div class="configurator-selection">
    <h3
      v-if="props.title"
      class="configurator-selection__title"
      :style="props.titleCustomStyle"
    >
      {{ $i18n(title) }}
    </h3>
    <div
      class="configurator-selection__options configurator-selection__options--radio"
      :class="{
        package: isInsidePackage,
        'justify-content-center': justifyContentCenter,
        'configurator-selection__options-next-to-others' : isNextToOthers,
        'single-option': singleOption,
      }"
      :style="{ ...(optionsContainerStyle ? optionsContainerStyle : {}) }"
    >
      <SelectOptionV4
        v-for="option in props.options"
        :key="option.id"
        :option="option"
        :selected="modelValue?.id == option.id"
        :show-description="props.showDescription"
        :show-information="props.showInformation"
        :disabled="disabled || disabledSelections.includes(option.id)"
        :single-option="singleOption"
        @click="select(option)"
      />
    </div>
  </div>
</template>
<style scoped>
  .configurator-selection__options-next-to-others {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 30em;
    height: 100%;
    width: 100%;
    padding: 0;
  }
  .configurator-selection__options {
    gap: var(--sdds-spacing-layout-32);
  }
  @media only screen and (max-width: 1000px) {
    .configurator-selection__options--radio:not(.package) {
      padding: 0 var(--sdds-spacing-layout-16) var(--sdds-spacing-layout-8);
    }
    .configurator-selection__options--radio.package {
      padding: 0 4px var(--sdds-spacing-layout-8);
    }
    .configurator-selection__options--radio.single-option {
      justify-content: center;
    }
  }
</style>

